import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Statement from "@/components/Statement";
import Story from "@/components/Story";
import Family from "@/components/Family";
import Ventures from "@/components/Ventures";
import Values from "@/components/Values";
import Legacy from "@/components/Legacy";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import "@/landing.css";

export default function Landing() {
  return (
    <div className="m10" data-testid="landing-page">
      <Header />
      <main id="home">
        <Hero />
        <Statement />
        <Story />
        <Family />
        <Ventures />
        <Values />
        <Legacy />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
